<template>
  <div>
    <template>
      <v-btn
        color="secondary"
        rounded
        dark
        style="color: #01288d"
        @click="showDialog"
      >
        Add New Driver
      </v-btn>
    </template>

    <WarningModal
      :handleConfirm="handleConfirm"
      v-if="$store.getters['Dashboard/showWarningModal']"
    />

    <SuccessModal v-if="$store.getters['Dashboard/showSuccessModal']" />
    <ErrorModal v-if="$store.getters['Dashboard/showErrorModal']" />

    <v-dialog
      v-model="$store.getters['Dashboard/driverCreationModal']"
      persistent
      max-width="800px"
    >
      <v-card color="#f4f7fc" style="background: white;" class="col-12">
        <v-btn
          x-small
          outlined
          @click="hideDialog"
          fab
          icon
          class="float-right mt-5 mr-5"
        >
          <v-icon c>
            mdi-close
          </v-icon>
        </v-btn>
        <v-card-title>
          <span
            style="font-family: inherit !important"
            class="text-h5 text-md-h4"
          >
            New Driver Details
            <br />
            <span style="font-family: inherit !important" class="text-body-1">
              Please Fill Driver's Bio Data and Payment Details</span
            >
          </span>
        </v-card-title>

        <v-card-text>
          <v-container fluid class="pa-0">
            <!-- Tabs for different steppers -->

            <v-tabs
              v-model="tab"
              grow
              fluid
              class="d-none d-md-block mb-2 mt-2 mb-md-8 mt-md-8"
            >
              <v-tabs-slider color="secondary"></v-tabs-slider>
              <v-tab ref="bioData">DRIVER'S BIO DATA</v-tab>
              <v-tab ref="paymentData" v-if="checkbox">PAYMENT DETAILS</v-tab>
            </v-tabs>

            <v-checkbox
              v-model="checkbox"
              value="true"
              label="Fill Payment Detail"
            ></v-checkbox>

            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-row v-if="bio" class="d-flex flex-column flex-md-row">
                  <v-col cols="12" md="6">
                    <span class="text-uppercase">First name</span>
                    <v-text-field
                      dense
                      rounded
                      filled
                      class="mt-2"
                      placeholder="First Name"
                      v-model="formData.first_name"
                      :rules="rules.first_name"
                      ref="first_name"
                    ></v-text-field>

                    <span class="text-uppercase">Drivers Email Address</span>
                    <v-text-field
                      rounded
                      filled
                      dense
                      class="mt-2"
                      placeholder="Drivers Email Address"
                      v-model="formData.email"
                      :rules="rules.email"
                      ref="email"
                    ></v-text-field>

                    <span class="text-uppercase"
                      >Driver's Assigned Location</span
                    >
                    <v-text-field
                      class="mt-2"
                      rounded
                      filled
                      dense
                      v-model="formData.area_of_operation"
                      :rules="rules.area_of_operation"
                      placeholder="Select Area of Operation"
                      ref="area_of_operation"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <span class="text-uppercase">Last name</span>
                    <v-text-field
                      dense
                      rounded
                      filled
                      class="mt-2"
                      placeholder="Last Name"
                      v-model="formData.last_name"
                      :rules="rules.last_name"
                      ref="last_name"
                    ></v-text-field>

                    <span class="text-uppercase">Phone Number</span>
                    <v-text-field
                      dense
                      rounded
                      filled
                      class="mt-2"
                      placeholder="Phone Number"
                      v-model="formData.phone_number"
                      :rules="rules.phone_number"
                      ref="phone_number"
                    ></v-text-field>

                    <span class="text-uppercase"
                      >Driver's Assigned Vehicle</span
                    >
                    <v-select
                      class="mt-2"
                      rounded
                      filled
                      dense
                      v-model="formData.vehicle_id"
                      :items="$store.getters['Dashboard/vehicles']"
                      item-text="reg_no"
                      item-value="id"
                      placeholder="Select Assigned Vehicle"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <p class="text-uppercase">upload the following</p>
                  </v-col>
                </v-row>
                <v-row class="d-flex flex-column flex-md-row">
                  <v-col>
                    <v-file-input
                      label="ID"
                      type="file"
                      color="secondary"
                      v-model="formData.id_photo"
                      :rules="rules.id_photo"
                      ref="id_photo"
                    ></v-file-input>
                  </v-col>
                  <v-col>
                    <v-file-input
                      label="License"
                      type="file"
                      color="secondary"
                      v-model="formData.driving_licence"
                      :rules="rules.driving_licence"
                      ref="driving_licence"
                    ></v-file-input>
                  </v-col>
                  <v-col>
                    <v-file-input
                      label="Good conduct"
                      type="file"
                      color="secondary"
                      v-model="formData.good_conduct"
                      :rules="rules.good_conduct"
                      ref="good_conduct"
                    ></v-file-input>
                  </v-col>
                  <v-col>
                    <v-file-input
                      label="Profile photo"
                      type="file"
                      color="secondary"
                      v-model="formData.profile_photo"
                      :rules="rules.profile_photo"
                      ref="profile_photo"
                    ></v-file-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    class="d-flex flex-column flex-sm-row justify-space-around"
                  >
                    <v-btn
                      large
                      rounded
                      @click="handleRequiredFields"
                      style="background-color: white; border: 2px solid #01288d !important; padding: 0 4rem;"
                      class="primary--text mb-8 mb-sm-0"
                      v-if="checkbox"
                    >
                      Proceed
                    </v-btn>
                    <v-btn
                      large
                      rounded
                      @click="handleSumbit"
                      v-if="!checkbox"
                      color="secondary"
                      class="primary--text"
                      style="padding: 0 4rem"
                      :loading="modalLoading"
                    >
                      Submit
                    </v-btn>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item>
                <v-row d-flex flex-column flex-md-row>
                  <v-col cols="12" md="6">
                    <span class="text-uppercase">Bank name</span>
                    <v-text-field
                      dense
                      class="mt-2"
                      flat
                      rounded
                      filled
                      placeholder="Enter Name"
                      v-model="formData.bank_name"
                      ref="bank_name"
                    ></v-text-field>

                    <span class="text-uppercase">Bank Branch Name</span>
                    <v-text-field
                      class="mt-2"
                      rounded
                      filled
                      dense
                      placeholder="Select Bank Branch"
                      v-model="formData.branch_name"
                    ></v-text-field>

                    <span class="text-uppercase">Swift Code</span>
                    <v-text-field
                      class="mt-2"
                      rounded
                      filled
                      dense
                      placeholder="Select Swift Code"
                      v-model="formData.swift_code"
                    ></v-text-field>

                    <span class="text-uppercase">Driver's KRA PIN</span>
                    <v-text-field
                      rounded
                      filled
                      class="mt-2"
                      dense
                      placeholder="Enter Number"
                      v-model="formData.kra_pin"
                      ref="kra_pin"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <span class="text-uppercase">Account Name</span>
                    <v-text-field
                      rounded
                      filled
                      class="mt-2"
                      dense
                      placeholder="Enter Number"
                      v-model="formData.account_name"
                      ref="account_name"
                    ></v-text-field>

                    <span class="text-uppercase">Account Number</span>
                    <v-text-field
                      rounded
                      filled
                      dense
                      placeholder="Enter Number"
                      class="mt-2"
                      v-model="formData.account_number"
                      ref="account_number"
                    ></v-text-field>

                    <span class="text-uppercase">National ID Number</span>
                    <v-text-field
                      rounded
                      filled
                      dense
                      class="mt-2"
                      placeholder="Enter National ID"
                      v-model="formData.national_id"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    class="d-flex flex-column flex-sm-row justify-space-around"
                  >
                    <v-btn
                      large
                      rounded
                      @click="$refs.bioData.$el.click()"
                      style="background-color: white; border: 2px solid #01288d !important; padding: 0 4rem;"
                      class="primary--text mb-8 mb-sm-0"
                    >
                      Back
                    </v-btn>
                    <v-btn
                      large
                      rounded
                      color="secondary"
                      style="padding: 0 4rem"
                      class="primary--text"
                      @click="handleSumbit"
                      :loading="modalLoading"
                    >
                      Submit
                    </v-btn>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import WarningModal from "@/components/Dashboard/Modals/WarningModal";
import SuccessModal from "@/components/Dashboard/Modals/SuccessModal";
import ErrorModal from "@/components/Dashboard/Modals/ErrorModal";
export default {
  name: "AddDriver",
  components: {
    WarningModal,
    SuccessModal,
    ErrorModal
  },

  data: () => ({
    bio: true,
    checkbox: false,
    dialog: false,
    tab: null,
    modalLoading: false,

    bankBranch: ["Nairobi", "Eldoret", "Kisumu", "Mombasa"],
    formData: {
      first_name: "",
      last_name: "",
      phone_number: "",
      email: "",
      id_photo: "",
      vehicle_id: "",
      area_of_operation: "",
      profile_photo: "",
      good_conduct: "",
      driving_licence: "",

      bank_name: "",
      branch_name: "",
      swift_code: "",
      kra_pin: "",
      account_name: "",
      account_number: ""
    }
  }),

  computed: {
    rules() {
      return {
        email: [
          value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(value) || "Invalid e-mail.";
          }
        ],
        first_name: [value => !!value || "Required."],
        last_name: [value => !!value || "Required."],
        phone_number: [value => !!value || "Required."],
        id_photo: [value => !!value || "Required."],
        profile_photo: [value => !!value || "Required."],
        good_conduct: [value => !!value || "Required."],
        driving_licence: [value => !!value || "Required."],
        area_of_operation: [value => !!value || "Required."]
      };
    },

    updateDriver() {
      return this.$store.getters["Dashboard/updateDriver"];
    }
  },

  methods: {
    handleRequiredFields() {
      let isValid = true;

      for (let key in this.rules) {
        isValid = isValid ? this.$refs[key].validate(true) : false;
      }

      if (isValid) {
        this.$refs.paymentData.$el.click();
      }
    },

    handleSumbit() {
      let isValid = true;

      for (let key in this.rules) {
        isValid = isValid ? this.$refs[key].validate(true) : false;
      }

      if (isValid) {
        const newFormData = new FormData();
        if (this.formData.id_photo instanceof File)
          newFormData.append(
            "id_photo",
            this.formData.id_photo,
            this.formData.id_photo.name
          );
        if (this.formData.profile_photo instanceof File)
          newFormData.append(
            "profile_photo",
            this.formData.profile_photo,
            this.formData.profile_photo.name
          );
        if (this.formData.driving_licence instanceof File)
          newFormData.append(
            "driving_licence",
            this.formData.driving_licence,
            this.formData.driving_licence.name
          );
        if (this.formData.good_conduct instanceof File)
          newFormData.append(
            "good_conduct",
            this.formData.good_conduct,
            this.formData.good_conduct.name
          );

        if (this.updateDriver.first_name)
          newFormData.append("id", this.updateDriver.id);

        newFormData.append("first_name", this.formData.first_name);
        newFormData.append("last_name", this.formData.last_name);
        newFormData.append("phone_number", this.formData.phone_number);
        newFormData.append("email", this.formData.email);
        newFormData.append("vehicle_id", this.formData.vehicle_id);
        newFormData.append(
          "area_of_operation",
          this.formData.area_of_operation
        );

        newFormData.append("bank_name", this.formData.bank_name);
        newFormData.append("branch_name", this.formData.branch_name);
        newFormData.append("swift_code", this.formData.swift_code);
        newFormData.append("kra_pin", this.formData.kra_pin);
        newFormData.append("account_name", this.formData.account_name);
        newFormData.append("account_number", this.formData.account_number);

        this.$store.dispatch("Dashboard/addNewDriver", newFormData);
      }
    },

    hideDialog() {
      this.$store.dispatch("Dashboard/hideDriverCreationModal");
    },

    showDialog() {
      this.$store.dispatch("Dashboard/showDriverCreationModal");
    },

    // handle Tab click
    handleTabOne() {
      this.bio = true;
      this.tabID = 1;
    },

    handleTabTwo() {
      this.bio = false;
      this.tabID = 2;
    }
  },

  created() {
    this.$store.dispatch("Dashboard/fetchVehicles");
  },

  mounted() {
    Event.$on("modalLoading", value => {
      this.modalLoading = value;
    });
  }
};
</script>
<style lang=""></style>
